module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fa":{"Your wallets":"کیف پول های شما","Value of cryptocurrency wallets (in Tomans)":"ارزش کیف پول های رمز ارز (به تومان)","Toman wallet balance":"موجودی کیف پول تومان","Value of cryptocurrency wallets (in usdt)":"ارزش کیف پول های رمز ارز (به دلار)"}}')
  delete Component.options._Ctor
}
